import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';

export type DialogSaveResult = 'save' | 'discard' | 'cancel';

export interface DialogSaveData {
    title: string;
    message: string;
}

@Component({
    selector: 'dialog-save',
    templateUrl: 'dialog-save.html',
    styleUrls: ['dialog-save.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogSave extends DialogGeneral {
    constructor(
        public dialogRef: MatDialogRef<DialogSave, DialogSaveResult>,
        @Inject(MAT_DIALOG_DATA) public data: DialogSaveData
    ) {
        super(dialogRef);
    }

    saveAndLeave(): void {
        this.dialogRef.close('save');
    }

    discardAndLeave(): void {
        this.dialogRef.close('discard');
    }

    cancel(): void {
        this.dialogRef.close('cancel');
    }
}
